import type { AxiosRequestConfig } from 'axios';

import { getOrCreateHeaders } from '@trialcard/shared';
import { Authentication } from './Authentication.js';
import type { IServiceContext } from './IServiceContext.js';
import { OAuthTokenProvider } from './OAuthTokenProvider.js';


export class OAuth extends Authentication {
    public accessToken: string = '';
    public constructor(private readonly context: IServiceContext, private readonly tokenProvider: OAuthTokenProvider) {
        super();
    }

    public async applyToRequest(requestOptions: AxiosRequestConfig): Promise<void> {
        if (!requestOptions) {
            return Promise.reject(new Error('Axios request config can\'t be null or undefined.'));
        }

        // TODO: ADD logic to deal with expired tokens
        // if (!this.accessToken) {
        // }
        const accessToken = await this.tokenProvider.getToken(this.context);
        if (accessToken) {
            getOrCreateHeaders(requestOptions)['Authorization'] = 'Bearer ' + accessToken;
        }

        return Promise.resolve();
    }
}
